(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('resizeTaskContainer', resizeTaskContainer);

	resizeTaskContainer.$inject = ['$rootScope', '$timeout', '$window'];

	function resizeTaskContainer($rootScope, $timeout, $window) {
		return {
			link: function (scope, element, attr) {
				jQuery(window).off('resize');
			}
		};
	}
})();
